import { useEffect, useRef, useCallback } from "react";
import { signOut } from "aws-amplify/auth";

const INACTIVE_TIMEOUT = 15 * 60 * 1000;  // 15 min idle → warning
const LOGOUT_TIMEOUT   =  5 * 60 * 1000;  // 5 min after warning → auto logout
const ACTIVITY_EVENTS  = ["mousedown","mousemove","keydown","scroll","touchstart","click"];

export function useSessionTimeout({ onWarning, onLogout }) {
  const idleTimer   = useRef(null);
  const logoutTimer = useRef(null);
  const warned      = useRef(false);

  const resetTimers = useCallback(() => {
    if (warned.current) return; // don't reset if warning shown — user must click Stay
    clearTimeout(idleTimer.current);
    clearTimeout(logoutTimer.current);
    idleTimer.current = setTimeout(() => {
      warned.current = true;
      if (onWarning) onWarning();
      // Start final countdown — logout after 5 more min
      logoutTimer.current = setTimeout(async () => {
        warned.current = false;
        if (onLogout) onLogout();
        try { await signOut(); } catch(e) {}
        window.location.href = "/";
      }, LOGOUT_TIMEOUT);
    }, INACTIVE_TIMEOUT);
  }, [onWarning, onLogout]);

  const stayActive = useCallback(() => {
    warned.current = false;
    clearTimeout(logoutTimer.current);
    resetTimers();
  }, [resetTimers]);

  useEffect(() => {
    resetTimers();
    ACTIVITY_EVENTS.forEach(e => window.addEventListener(e, resetTimers, { passive: true }));
    return () => {
      clearTimeout(idleTimer.current);
      clearTimeout(logoutTimer.current);
      ACTIVITY_EVENTS.forEach(e => window.removeEventListener(e, resetTimers));
    };
  }, [resetTimers]);

  return { stayActive };
}
